import React from "react";
import { BenefitCardProps } from "./types";

const BenefitCard: React.FC<BenefitCardProps> = ({
  icon,
  title,
  description,
}) => (
  <div className="benefit-card">
    <div className="benefit-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const Benefits: React.FC = () => {
  const benefits = [
    {
      icon: "🌳",
      title: "Conexión con la Naturaleza",
      description: "Vive rodeado de bosques, ríos y aire puro cada día.",
    },
    {
      icon: "👨‍👩‍👧‍👦",
      title: "Proyecto Familiar",
      description: "Construye tu hogar y comunidad con nosotros.",
    },
    {
      icon: "🤝",
      title: "Desarrollo Rural",
      description: "Traemos nuevos habitantes y oportunidades al pueblo.",
    },
    {
      icon: "🔍",
      title: "Proceso Cercano",
      description: "Comunicación directa, trato cercano y sin sorpresas.",
    },
  ];

  return (
    <section id="beneficios" className="benefits">
      <div className="container">
        <h2>¿Por qué vender directamente con nosotros?</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <BenefitCard
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
